module.exports = __webpack_public_path__ + "img/general-group-seating-map-2.76900271.jpg";